import {
	Button, Icon
} from "~/components";
import { Tooltip } from "antd";

function ProductCategoryAction({ item, onEdit, onDelete, can}) {

	const buttonHandlers = {
		edit: () => {
			onEdit(item);
		},
		delete: () => {
			onDelete(item);
		}
	};

	return (
		<div className="table-action d-flex">
			{(can.edit ) && (<Tooltip title="Cập nhật thông tin"><Button background blue noneBorder leftIcon={Icon.edit} onClick={buttonHandlers.edit} /></Tooltip>)}
			{can.delete && (
				<Tooltip title="Xóa danh mục">
					<Button background red noneBorder leftIcon={Icon.delete} onClick={buttonHandlers.delete} />
				</Tooltip>
			)}
		</div>
	);
}

export default ProductCategoryAction;
